export const DEFAULT_EMAIL = 'example@test.com'
export const CONFIRMATION_TYPES = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
}
export const CONFIRMATION_TYPES_LABELS = {
  [CONFIRMATION_TYPES.EMAIL]: 'Email',
  [CONFIRMATION_TYPES.SMS]: 'Phone',
}
